import type { Point } from "./layout";

type Props = { from: Point; to: Point; color: string; dashed?: boolean };
export function RoutePath({ from, to, color, dashed }: Props) {
  return (
    <g class="route-path">
      <path
        d={`M ${from.x} ${from.y} L ${to.x} ${to.y}`}
        fill="none"
        stroke={color}
        stroke-width="3.4"
        stroke-dasharray={dashed ? "10 8" : undefined}
        opacity=".95"
      />
      <rect
        class="route-junction route-junction-start"
        x={from.x - 6}
        y={from.y - 6}
        width="12"
        height="12"
        fill="var(--bg)"
        stroke={color}
        stroke-width="2.2"
      />
      <rect
        class="route-junction route-junction-end"
        x={to.x - 6}
        y={to.y - 6}
        width="12"
        height="12"
        fill="var(--bg)"
        stroke={color}
        stroke-width="2.2"
      />
    </g>
  );
}
